import { RouteConfig } from "vue-router";

export const REmployeeProfileCompanyDataHistory: RouteConfig = {
  path: "history",
  name: "EmployeeProfileCompanyDataHistory",
  component: () =>
    import(
      /* webpackChunkName: "employee-profile-company-data-history" */
      "./VEmployeeProfileCompanyDataHistory.vue"
    ),
  meta: {
    title: "My Profile",
    label: "data history",
    tabName: "employee_profile_company_data_history",
    alias: "data_history",
  },
};
